import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    noReadNum: '',
    domain: '',
    latestNews: [],
    classification: [],
    areaList: []
  },
  mutations: {
    setNoReadNum(state, noReadNum) {
      state.noReadNum = noReadNum
    },
    setDomain(state, domain) {
      state.domain = domain
    },
    setLatestNews(state, latestNews) {
      state.latestNews = latestNews
    },
    setClassification(state, classification) {
      state.classification = classification
    },
    setAreaList(state, areaList) {
      state.areaList = areaList
    }
  },
  actions: {

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js